import { Component, OnInit } from '@angular/core';
import { LogService } from '../_shared/log.service';

@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.less']
})
export class StudentComponent implements OnInit {

  public routeVal = '';
  receiveVal($event){
    this.routeVal = $event;
  }

  constructor(private eventService: LogService) { }

  public newData = ''
  ngOnInit(): void {
    this.eventService.on<string>().subscribe(
      data => {
        this.newData = data
        this.routeVal = this.newData
        console.log(this.newData +"final")
      }
    )
  }


}
